import React from 'react';
import _get from 'lodash/get';
import { Slider, Text } from 'wix-style-react';
import BaseFilter from '../BaseFilter/BaseFilter';
import s from './budgetFilter.scss';
import {
  MIN_BUDGET,
  MAX_BUDGET,
  MAX_POSSIBLE_BUDGET,
} from '../../../../utils/constants';

const splitBudgetToFilterValues = budget => ({
  lower: budget[0],
  upper: budget[1] === MAX_BUDGET ? MAX_POSSIBLE_BUDGET : budget[1],
});

const BudgetFilter = ({
  filterTitle,
  applyButtonText,
  clearButtonText,
  text,
  rangeText,
  maxPlusSign,
  onApply,
  onChange,
  currentBudget,
}) => {
  const lower = _get(currentBudget, 'lower', MIN_BUDGET);
  const upper = _get(currentBudget, 'upper', MAX_BUDGET);
  return (
    <BaseFilter
      filterDataHook="explore-price-filter"
      filterTitle={filterTitle}
      applyButtonText={applyButtonText}
      clearButtonText={clearButtonText}
      applyButtonDataHook="explore-price-filter-apply-button"
      clearButtonDataHook="explore-price-filter-clear-button"
      isClearDisabled={lower === MIN_BUDGET && upper >= MAX_BUDGET}
      onApply={() => onApply({ lower, upper })}
      onClear={() => onChange({ lower: undefined, upper: undefined })}
    >
      <div className={s.filterContent}>
        <div className={s.currentPricesText}>
          {/* Set a price range between ${{ min }} - ${{ max }}{{ max_plus_sign }}*/}
          <Text size="medium" skin="standard" tagName="div" weight="thin">
            {text}
          </Text>
          <Text size="medium" skin="standard" tagName="div" weight="bold">
            {rangeText
              .replace('{MIN_PLACEHOLDER}', lower.toLocaleString())
              .replace(
                '{MAX_PLACEHOLDER}',
                upper < MAX_BUDGET
                  ? upper.toLocaleString()
                  : MAX_BUDGET.toLocaleString(),
              )
              .replace(
                '{MAX_PLUS_SIGN}',
                upper < MAX_BUDGET ? '' : maxPlusSign,
              )}
          </Text>
        </div>
        <div className={s.sliderWrapper}>
          <Slider
            min={MIN_BUDGET}
            max={MAX_BUDGET}
            value={[lower, upper]}
            allowCross={false}
            displayTooltip={false}
            displayMarks={false}
            onChange={value => onChange(splitBudgetToFilterValues(value))}
          />
        </div>
      </div>
    </BaseFilter>
  );
};

export default BudgetFilter;
